import { Controller } from "@hotwired/stimulus";

// Plays one call recording at a time: starting one pauses any other on the page, including those in the
// contact modal's history.
export default class extends Controller {
  pauseOthers(event) {
    document.querySelectorAll("audio").forEach((audio) => {
      if (audio !== event.target) audio.pause();
    });
  }
}
